import { uploadMedia } from '../../../api/media/upload'
import { FilesType } from '../../constants/files'
import { FileInput } from '../../types/models/file/file-input'
import { NullableTransformer } from '../../types/utils'

export async function uploadFile(
  destination: FilesType,
  file?: NullableTransformer<FileInput> | null
): Promise<FileInput | null | undefined> {
  if (!file) return file
  const path = await uploadMedia({ file: file.path, folder: destination })

  // remove extension from name and adding the path extension to it since the path
  // extension is not the same as the file extension when the file is uploaded
  const nameWithoutExtension = file.name.split('.').slice(0, -1).join('.')
  const pathExtension = path.split('.').pop()
  const name = `${nameWithoutExtension}.${pathExtension}`
  const caption = file.caption ?? undefined

  return { path, name, type: file.type, size: file.size, caption }
}
